
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/smart-quote/[dealId]",
      function () {
        return require("private-next-pages/smart-quote/[dealId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/smart-quote/[dealId]"])
      });
    }
  